import "@dearbill/shared/styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PortalAuthProvider } from "@dearbill/shared";
import { PARTNER_AUTH_CONFIG } from "./auth/partnerAuthConfig";
import { App } from "./App";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Could not find #root element to mount into.");

createRoot(rootEl).render(
  <StrictMode>
    <PortalAuthProvider config={PARTNER_AUTH_CONFIG}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PortalAuthProvider>
  </StrictMode>,
);
